<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="主播昵称：">
            <el-input v-model="query.liveName" placeholder="请输入昵称" clearable size="small" />
          </el-form-item>
          <el-form-item label="主播身份：">
            <el-select v-model="query.position" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option 
                v-for="item in identityList" 
                :key="item.value" 
                :label="item.label" 
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限状态：">
            <el-select v-model="query.state" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="handleExport" plain>导出</el-button> -->
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加主播</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="主播姓名" prop="realName" align="center" fixed="left" />
        <el-table-column label="主播昵称" prop="liveName" align="center" />
        <el-table-column label="主播身份" prop="positionName" align="center" />
        <el-table-column label="主播手机号" prop="userPhone" align="center" />
        <el-table-column label="直播次数" prop="liveCount" align="center" />
        <el-table-column label="直播总时长" prop="liveTotalSecond" align="center" />
        <el-table-column label="下单数量" prop="killOrderCount" align="center" :formatter="orderCountFormatter" />
        <el-table-column label="打赏次数" prop="rewardCount" align="center" />
        <el-table-column label="直播预告" prop="liveWillCount" align="center" />
        <el-table-column label="最近直播时间" prop="lastLiveTime" align="center" />
        <el-table-column label="权限状态" prop="state" align="center">
          <template slot-scope="{row}">
            {{ row.state === 1 ? '启用' : '禁用' }}
          </template>
        </el-table-column>
        <el-table-column label="添加时间" prop="createdTime" align="center" />
        <el-table-column label="操作时间" prop="operatedTime" align="center" />
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">查看</el-button>
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleState(row)">{{row.state ? '禁用' : '开启'}}主播身份</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <live-add ref="liveAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import liveAdd from './add'
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'
import { Subtr } from '@/utils/index'
import enums from '@/utils/enums'
export default {
  components: {
    Pagination,
    liveAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      identityList: []
    }
  },
  created() {
    this.getIdentityList()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleExport() {
      this.$message && this.$message.info('导出功能开发中')
    },
    /**
     * 获取身份列表
     */
    getIdentityList() {
      const liveAnchorLevel = enums.getLiveAnchorLevel()
      this.identityList = Object.values(liveAnchorLevel).map(item => ({
        value: item.value,
        label: item.label
      }))
    },
    orderCountFormatter(row) {
      return Subtr(row.killOrderCount, row.yueOrderCount)
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return liveManageApi.fetchListAnchor(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleState(row) {
      let txt = row.state === 1 ? '确认禁用？' : '确认启用？'
      this.$common.confirm(txt).then(() => liveManageApi.statusBatchAnchor({ ids: [row.id], status: row.state === 1 ? 0 : 1 }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.liveAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.liveAdd.handleUpdate(row)
    }
  }
}
</script>
